import { call, put, takeEvery } from 'redux-saga/effects';
import { getBikeVariants } from '../../requests/get_bike_variants_request';
import { getBikeVariantsSuccess, getBikeVariantsFailure } from '../actions/get_bike_variants.actions';
import { GET_BIKE_VARIANTS_REQUEST } from '../constants/get_bike_variants.constants';

function* getBikeVariantsRequest({ params }) {
    const variants = yield call(getBikeVariants, params); const
        { msg, result, options } = variants;

    result
        ? yield put(getBikeVariantsSuccess(options))
        : yield put(getBikeVariantsFailure(msg));
}

export default function* getBikeVariantsSaga() {
    yield takeEvery(GET_BIKE_VARIANTS_REQUEST, getBikeVariantsRequest);
}



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_create/redux/sagas/get_bike_variants.saga.js